import { useState } from "react";

import {
  ConfettiPop,
  DigitalWallet,
  InvoiceId,
  PaymentLinkId,
  Peer2Peer,
} from "../../../../../public/assets";
import { colors } from "../../../../theme/color";
import Buttons from "../../../Button/button.component";
import {
  HomeProductWrapper,
  HomeProductModal,
  HomeProductHeader,
  HomeProductCloseButton,
  HomeProductText,
  HomeProductDetail,
  HomeProductImg,
  HomeProductBody,
  HomeProductBodyText,
  HomeProductCard,
  HomeProductMapped,
  HomeProductButton,
  HomeButtonCancel,
  HomeButtonContinue,
} from "./HomeProduct.styles";
import HomeProductsCard from "./HomeProductsCard";
import { useNavigate } from "react-router-dom";
import WelcomeModal, {
  ModalWrapper,
} from "../../../WelcomeToFipayModal/WelcomeModal";
interface HomeProductCards {
  id: number;
  icon: string;
  title: string;
  description: string;
  buttonTitle: string;
  route: string;
}

const HomeProductCards: HomeProductCards[] = [
  {
    id: 1,
    icon: "/assets/svg/paymentlinkId.svg",
    title: "Payment Link",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Create Payment Link",
    route: "/dashboard",
  },
  {
    id: 2,
    icon: "/assets/svg/invoiceId.svg",
    title: "Invoice   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Create Invoice",
    route: "",
  },
  {
    id: 3,
    icon: "/assets/svg/peer2peer.svg",
    title: "Peer-to-Peer   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
    route: "",
  },
  {
    id: 4,
    icon: "/assets/svg/digitalWalletId.svg",
    title: "Digital Wallet   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
    route: "",
  },
];

const HomeProduct = ({ handleSkip }: { handleSkip: () => void }) => {
  // const [data, setData] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState<number | null>(null);
  const [modalOpen, setModalOpen] = useState(true);
  const navigate = useNavigate();

  const handleClick = (id: number) => {
    console.log("id ", id);
    setSelectedCardId(id === selectedCardId ? null : id);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    handleSkip();
  };

  const handleContinueClick = () => {
    console.log("Continue button clicked");
    if (selectedCardId !== null) {
      const selectedCard = HomeProductCards.find(
        (card) => card.id === selectedCardId
      );
      if (selectedCard) {
        navigate(selectedCard.route);
      }
    } else {
      console.log("No card selected");
    }
  };
  const handleSkipClick = () => {
    handleSkip();
  };

  return (
    <div>
      {modalOpen && (
        <ModalWrapper>
          <HomeProductWrapper>
            <HomeProductModal>
              <HomeProductHeader>
                <HomeProductDetail>
                  <HomeProductText>Welcome To Fipay </HomeProductText>
                  <HomeProductImg src="/assets/svg/Bitmap.jpg" />
                </HomeProductDetail>
                <HomeProductCloseButton onClick={handleCloseModal}>
                  x
                </HomeProductCloseButton>
              </HomeProductHeader>

              <HomeProductBody>
                <HomeProductBodyText>
                  Which of our products would you like to explore or skip to
                  complete you account set-up
                </HomeProductBodyText>

                <HomeProductCard>
                  {HomeProductCards.map((cards) => (
                    <HomeProductMapped key={cards.id}>
                      <HomeProductsCard
                        cards={cards}
                        handleClick={handleClick}
                        isSelected={cards.id === selectedCardId}
                      />
                    </HomeProductMapped>
                  ))}
                </HomeProductCard>
                <HomeProductButton>
                  <HomeButtonCancel>
                    <Buttons
                      label="Skip"
                      cursor="pointer"
                      border="10px"
                      width="100%"
                      height="50px"
                      borderLine="1px solid #AFAFAF"
                      color={colors.White}
                      textColor={colors.BLACK}
                      handleClick={handleSkipClick}
                      style={{
                        width: "70%",
                        height: "44px",
                        borderRadius: "10px",
                        border: "1px solid #AFAFAF",
                        color: "#AFAFAF",
                        backgroundColor: "white",
                      }}
                    />
                  </HomeButtonCancel>
                  <HomeButtonContinue>
                    <Buttons
                      label="Continue"
                      cursor="pointer"
                      border="10px"
                      width="100%"
                      height="50px"
                      color={colors.ButtonBackgroundColors.primaryDefaultButton}
                      handleClick={handleContinueClick}
                      style={{
                        width: "100%",
                        height: "44px",
                        borderRadius: "10px",
                        color: "white",
                        backgroundColor: "#00A603",
                      }}
                    />
                  </HomeButtonContinue>
                </HomeProductButton>
              </HomeProductBody>
            </HomeProductModal>
          </HomeProductWrapper>
        </ModalWrapper>
      )}
    </div>
  );
};

export default HomeProduct;
